module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('CommentPanel', {
    attrs: {
      "commentData": _vm.commentData,
      "appId": _vm.appId,
      "inPanel": true
    },
    on: {
      "openModal": _vm.openCommentsModal
    }
  }), _vm._v(" "), _c('AllCommentsModal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showComments),
      expression: "showComments"
    }],
    attrs: {
      "commentData": _vm.commentData,
      "appId": _vm.appId
    },
    on: {
      "closeModal": _vm.closeCommentsModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3fa3c9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommentBloc/CommentBloc.vue
// module id = 3386
// module chunks = 0